import { action, makeAutoObservable, flow } from 'mobx'
import AsyncStorage from '@react-native-community/async-storage'
import api from '../api'
import _ from 'lodash'

class UserCouponStore {
    isLoading = false
    coupon = undefined

    constructor() {
        makeAutoObservable(this)
    }

    getUserCoupon = flow(function* (userCouponId) {
        try {
            const token = yield AsyncStorage.getItem('@token')
            const response = yield api.getUserCoupon(token, userCouponId)
            this.coupon = response.data
            return Promise.resolve()
        }
        catch (error) {
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    redeemUserCoupon = flow(function* (userCouponId) {
        try {
            this.isLoading = true
            const token = yield AsyncStorage.getItem('@token')
            yield api.redeemUserCoupon(token, userCouponId)
            this.coupon.status = 'INACTIVE'
            this.isLoading = false
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })
}

export default new UserCouponStore()